module.exports = __webpack_public_path__ + "static/media/group-to-person.b1f0ced5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/group-to-person.jpg
// module id = 1916
// module chunks = 0